<template>
    <div class="faq">
        <Nav :isFixed='bannerFixed'></Nav>
       <div class="faq-banner">
            <div class="main-text">
                <p class="headline">Frequently Asked <span class="underline">Questions?</span></p>
            </div>
        </div>
        <div class="faq-main container">
            <ul class="faq-left">
                <li class="question-list" :class="{'active': i==activeItem}" v-for="(item,i) in questionList" :key='i' @click="choseQuestion(i)">{{ item }}</li>
            </ul>
            <div class="faq-right">
                <el-collapse v-model="activeItem" accordion>
                    <el-collapse-item :title="item.q" v-for="(item,i) in aqList" :key='i' :name="i" class="collapse-item">
                        <div>{{ item.a }}</div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>
<script>
import Nav from '../components/pc/nav.vue'
import { faqList } from '@/utils/faqList'
import Bottom from '../components/pc/bottom.vue'
export default {
    data () {
        return {
            bannerFixed: false,
            questionList: [
                '1.What is BlueRidgeBank?',
                '2.How do I start',
                '3.Are there charges?',
                '4.How much can I start with?',
                '5.How safe is?',
                '6.Contact us?',
                '7.Are my card details safe?',
                '8.Saving anytime?',
                '9.Daily Interest?',
                '10.Withdraw anytime?',
                '11.Withdraw arrive time?',
                '12.Withdraw failure after 48h?',
                '13.Interest tax?',
                '14.BVN',
                '15.Do you give loans?',
                '16.How to remove/delete saved debit cards?'
            ],
            aqList: faqList,
            activeItem: 0
        }
    },
    components: {
        Nav,
        Bottom
    },
    mounted () {
        this.handleScroll()
        window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        choseQuestion (index) {
            this.activeItem = index
        },
        handleScroll () {
            if (window.scrollY > 80) {
                this.bannerFixed = true
            } else {
                this.bannerFixed = false
            }
        }
    }
}
</script>
<style lang='scss'>
@import '@/styles/public.scss';
.faq{
    .faq-banner{
        width: 1440px;
        height: 846px;
        background-image: url('~@/assets/img/faq/faq-banner.png');
        background-repeat: no-repeat;
        background-size: contain;
        position: relative;
        overflow: hidden;
        padding-top: 80px;
        .main-text{
            position: absolute;
            top: 273px;
            left: 140px;
            width: 606px;
            .headline{
                font-size: 66px;
                color: #060F27;
                margin-bottom: 16px;
                font-weight: bold;
                .underline{
                    color: $theme-color;
                    display: inline-block;
                    border-bottom: 3px solid $theme-color;
                    line-height: 55px;
                }
            }
        }
    }
    .faq-main{
        overflow: hidden;
        display: flex;
        padding-top: 90px;
        .faq-left{
            width: 300px;
            height: 700px;
            float: left;
            padding: 10px 31px 80px 0 ;
            background-color: #fff;
            border: 1px solid #D8D8D8;
            border-radius: 8px;
            .question-list{
                min-height: 40px;
                color: #333;
                font-weight: bold;
                font-size: 16px;
                line-height: 40px;
                padding-left: 20px;
                &.active{
                    width: 269px;
                    height: 40px;
                    background: $theme-color;
                    border-radius: 0 20px 20px 0 ;
                    color: #fff;
                }
            }
        }
        .faq-right{
            float: left;
            margin-left: 58px;
            flex: 1;
            .el-collapse{
                border: none;
                .el-collapse-item__header{
                    font-size: 26px;
                    font-weight: bold;
                    color: $theme-color;
                    height: auto;
                    line-height: 30px;
                    border-bottom: none;
                    margin-bottom: 17px;
                }
                .collapse-item{
                    white-space: pre-wrap;
                    margin-bottom: 50px;
                }
                .el-collapse-item__wrap{
                    border: none;
                    .el-collapse-item__content{
                        padding-left: 20px;
                        font-size: 16px;
                        color: #333;
                        font-weight: bold;
                    }
                }
            }
        }

    }
}
</style>
